import CircularLoader from "component/circularLoader/CircularLoader";
import { ROUTES } from "lib/Constants";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store/store";

const LoggedInWrapper = ({ children }: { children: React.ReactNode }) => {
	const { isAuth, loading } = useSelector((store: RootState) => store.auth);

	if (loading) {
		return <div className="flex-wrap align-center justify-center w-full h-100">	<CircularLoader /></div>;
	} else if (isAuth) {
		return <>{children}</>;
	} else {
		return <Navigate to={ROUTES.LOGIN} replace />;
	}
};

export default LoggedInWrapper;
